<!-- eslint-disable max-len -->
<template>
  <div>
    <h3 class="modal-title">Layer Access Page</h3>

    <!-- Page -->
    <div class="menu-row-access-application">
      <b-row class="pr-2">
        <b-col
          cols="5"
          class="d-flex">
          <img
            :src="selectedPages.icon_grey"
            height="16"
            width="16"
            class="m__t--5">
          <div class="m__l--10">
            <div class="page-name">{{ selectedPages.name.toUpperCase() }}</div>
            <div class="page-id">{{ selectedPages.id }}</div>
          </div>
        </b-col>
        <b-col
          cols="6"
          class="border-left">
          <div class="page-type"> {{ selectedPages.type === 'visible' ? 'VISIBLE AT MENU' : 'MENU TITLE' }} </div>
        </b-col>
      </b-row>
    </div>

    <!-- Config -->
    <div class="wrap-config">
      <div
        class="d-flex justify-content-between align-items-center"
        style="padding-right: 38px;"
      >
        <p class="title m-0"> Config Security Pages </p>
        <j-toggle
          v-model="useConfig"
          style="height: 20px;"
        />
      </div>

      <div v-if="useConfig">
        <b-row class="session-access">
          <b-col cols="12">
            <b-form-group>
              <label> Security Type </label>
              <b-form-radio-group
                v-model="dataSetup.security_type"
                :options="listSecurityType"
                class="jFormGroup"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div
          v-if="dataSetup.security_type === 'otp'"
          class="session-access"
        >
          <p class="section-title mb-2">Verification OTP Method</p>

          <div class="otp-verification">
            <div
              v-for="otp in verificationOTP"
              :key="otp.key"
              :class="{
                'active': dataSetup.otp_method === otp.key,
              }"
              class="otp-verification-list"
              @click="setSelectedOtpMethod(otp.key)"
            >
              <p>{{ otp.name }}</p>
              <span v-if="otp.desc">{{ otp.desc }}</span>
            </div>
          </div>

          <b-row class="session-access">
            <b-col cols="12">
              <b-form-group v-if="dataSetup.otp_method === 'function'">
                <label class="mb-1 mr-2"> Function </label>
                <j-single-select
                  v-model="functionPages"
                  :options="listFunction"
                  placeholder="Select Function"
                  label="name"/>
              </b-form-group>
            </b-col>
            <b-col cols="7">
              <b-form-group>
                <label class="mb-1 mr-2"> OTP Session Access </label>
                <j-single-select
                  v-model="dataSetup.otp_session"
                  :options="otpSessionAccess"
                  placeholder="Select otp session"/>
              </b-form-group>
            </b-col>
            <b-col cols="5">
              <b-form-group>
                <label class="mb-1 mr-2"> Standby Session Access </label>
                <j-single-select
                  v-model="dataSetup.standby_session"
                  :options="standbySessionAccess"
                  placeholder="Select standby session"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <div v-if="dataSetup.security_type === 'password'">
          <div class="information">
            <img src="@/assets/icon/info.svg" >
            <div>
              <p>Information</p>
              <span>If you implement security type password on layer access page, users will be required to enter their own password before accessing the page.</span>
            </div>
          </div>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="mb-1 mr-2"> Standby Session Access </label>
                <j-single-select
                  v-model="dataSetup.standby_session"
                  :options="standbySessionAccess"
                  placeholder="Select standby session"/>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <div class="float-right m__t--10">
      <b-button
        class="btn m__r--5"
        @click="closeModal">
        Close
      </b-button>
      <b-button
        class="btn blue"
        @click="submitConfig">
        Save
      </b-button>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: {
    listFunction: {
      type: Array,
      default: () => [],
    },
    selectedPages: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      verificationOTP: [
        { key: 'email', name: 'Email' },
        // { key: 'sms', name: 'SMS' },
        { key: 'function', name: 'Function', desc: 'Visual Programming' },
      ],
      otpSessionAccess: [
        { id: '5 Minutes', text: '5 Minutes' },
        { id: '10 Minutes', text: '10 Minutes' },
        { id: '15 Minutes', text: '15 Minutes' },
      ],
      standbySessionAccess: [
        { id: '1 Minutes', text: '1 Minutes' },
        { id: '5 Minutes', text: '5 Minutes' },
        { id: '10 Minutes', text: '10 Minutes' },
        { id: '15 Minutes', text: '15 Minutes' },
      ],
      listSecurityType: [
        { value: 'password', text: 'Password' },
        { value: 'otp', text: 'One-time Password (OTP)' },
      ],
      useConfig: false,
      getFromApi: false,
      dataSetup: {
        application_id: '',
        page_id: '',
        security_type: 'password',
        otp_method: '',
        function_name: '',
        otp_session: '10 Minutes',
        standby_session: '5 Minutes',
      },
      functionPages: null,
    };
  },

  watch: {
    functionPages(val) {
      if (val) {
        this.dataSetup.function_name = val;
      } else {
        this.dataSetup.function_name = '';
      }
    },

    // eslint-disable-next-line func-names
    'dataSetup.security_type': function (val) {
      if (val === 'otp') {
        if (!this.dataSetup.otp_session) this.dataSetup.otp_session = '10 Minutes';
      }
    },

    useConfig(val) {
      if (!val) {
        this.alertDisable();
      } else if (val) {
        if (!this.getFromApi) {
          this.dataSetup.security_type = 'password';
          this.dataSetup.standby_session = '5 Minutes';
        }
      }
    },
  },

  created() {
    this.getPageData();

    if (this.selectedPages) {
      this.dataSetup.application_id = this.selectedPages.application_id;
      this.dataSetup.page_id = Number(this.selectedPages.id);
    }
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapActions('jStoreSecurityPage', ['actionGetSecurityPages', 'actionSetSecurityPages']),

    closeModal() {
      this.$emit('close-modal');
    },

    getPageData() {
      if (this.selectedPages) {
        const data = {
          applicationId: this.selectedPages.application_id,
          filter: {
            page_id: this.selectedPages.id,
          },
        };

        this.actionGetSecurityPages(data).then((res) => {
          if (!res.error) {
            this.setConfigPages(res.data[0]);
          }
        });
      }
    },

    setSelectedOtpMethod(otpKey) {
      this.dataSetup.otp_method = otpKey;
    },

    alertDisable() {
      this.$swal({
        title: 'Update Record Pages',
        text: 'Are you sure want to disable this page?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.getFromApi = false;
          this.disablePages();
        } else {
          this.useConfig = !this.useConfig;
        }
      });
    },

    disablePages() {
      this.dataSetup.security_type = '';
      this.dataSetup.otp_method = '';
      this.dataSetup.function_name = '';
      this.dataSetup.function_name = '';
      this.dataSetup.otp_session = '';
      this.dataSetup.standby_session = '';

      this.actionSetSecurityPages(this.dataSetup).then((res) => {
        if (!res.error) {
          this.setConfigPages(res.data[0]);
        }
      });
    },

    submitConfig() {
      if (this.dataSetup.security_type === 'password') {
        this.dataSetup.otp_method = '';
        this.dataSetup.otp_session = '';
        this.dataSetup.function_name = '';
        this.functionPages = '';

        this.actionSetSecurityPages(this.dataSetup).then((res) => {
          if (!res.error) {
            this.setConfigPages(res.data[0]);
          }
        });
      }

      if (this.dataSetup.security_type === 'otp') {
        if (!this.dataSetup.otp_method) {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'OTP Method is not selected');
        } else {
          this.actionSetSecurityPages(this.dataSetup).then((res) => {
            if (!res.error) {
              this.setConfigPages(res.data[0]);
            }
          });
        }
      }
    },

    setConfigPages(data) {
      if (data) {
        this.dataSetup.security_type = data.security_type;
        this.dataSetup.otp_method = data.otp_method;
        this.dataSetup.otp_session = data.otp_session;
        this.dataSetup.function_name = data.function_name;
        this.dataSetup.standby_session = data.standby_session;
        this.functionPages = data.function_name || null;

        if (data.security_type) {
          this.useConfig = true;
          this.getFromApi = true;
        } else {
          this.getFromApi = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-title {
    color: #9A9A9A !important;
    letter-spacing: 0.01rem;
    font-family: 'Poppins-Bold';
  }

  .wrap-config {
    border: 1px solid #E7E7E7;
    border-radius: 12px;
    padding: 18px;

    .title {
      font-family: 'Poppins-Bold';
      font-size: 14px;
      color: #8A8A8A;
      margin-bottom: 0;
    }

    .section-title {
      font-family: 'Poppins-Medium';
      font-size: 12px;
      color: #808285;
    }

    .otp-verification {
      display: grid;
      grid-gap: 12px;
      grid-template-columns: repeat(2, 1fr);
      margin-top: 14px;

      &-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 76px;
        border: 1px solid #E2E2E2;
        border-radius: 10px;
        background-color: white;
        color: #8c8c8c;
        cursor: pointer;

        p {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 0;
          text-align: center;
        }
        span {
          font-size: 11px;
          margin-top: 1px;
          text-align: center;
        }
      }
      .active {
        background-color: #F5FAFF;
        border-color: #1A85E4;
        color: #1A85E4;
      }
      .disable {
        background-color: #f2f2f2;
        cursor: not-allowed;
      }
    }

    .information {
      width: 100%;
      background-color: #F5FAFF;
      border-radius: 8px;
      padding: 16px 10px;
      margin: 10px 0;
      display: flex;
      align-items: flex-start;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
      p {
        font-family: 'Poppins-Medium';
        font-size: 14px;
        color: #696014;
        margin-bottom: 5px;
      }
      span {
        font-family: 'Poppins-Regular';
        font-size: 12px;
        color: #696014;
      }
    }

    .session-access {
      margin-top: 14px;

      label {
        font-family: 'Poppins-Medium';
        font-size: 12px;
        color: #808285;
        font-weight: 500;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/access/components/jPopupSecurityPage.vue